import React from "react";
import PageAccessDenied from "@mnemonic/mui5/PageAccessDenied";
import { getMetaInfo } from "@mne-core/providers";
const NoAccessPage = () => <PageAccessDenied contact={getMetaInfo().email}/>;
export default NoAccessPage;
